﻿import { defineComponent, ref } from 'vue';
declare global { interface Window { ttcPaymentgateway: any; } }

import { Payment } from "../../../services/payment";
import { payment_response } from "../../../objects/ttc/payment_response/response";
import { DataPayload, PayPalOrder } from "../../../objects/v1_3/payment/initialise/paypal_order"
import { resp } from "../../../objects/ttc/payment_response/resp";
import { response } from "../../../objects/v1_3/payment/initialise/response";
//import payment_paypal_button from "./payment_paypal_button.vue";
import { response_method } from "../../../objects/v1_3/payment/initialise/response_method";
import { booking_search_group } from "../../../objects/v1_2/Booking_Details/booking_search_group";

import { payment } from "../../../objects/ttc/payment_gateway/payment";
import { request_payment_initialise_internal } from "../../../objects/v1_3/payment/initialise/request_payment_initialise_internal";
import { response_login_payment } from "../../../objects/agent/identity/v1_3/response_login_payment";
import { payment_transaction } from 'modules/tms/booking_engine/objects/ttc/payment_gateway/payment_transaction';
import { Booking } from "../../../services/booking";
import { return_status } from 'modules/tms/booking_engine/objects/v1_3/return_status';

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
const Pay: Payment = new Payment();
const Book: Booking = new Booking();

class supportedProviderMethod {
    public name: string = "";
    public accepts: string[] = []
}

export default defineComponent({
    name: "payment_credit_card",
    components: {
        //payment_paypal_button
    },
    props: {
        consumer_display: String,
        credit_card_div: String,
        paymentprovider_div_button: String,
        paymentprovider_div_frame: String,
        paymentprovider_iframe: HTMLElement
    },
    setup() {
        // const paypalButtonRef = ref<InstanceType<typeof payment_paypal_button> | null>(null);
        // const initPaypal = () => { paypalButtonRef.value?.initialisePaypal(); };        
        return {
            // paypalButtonRef,
            // initPaypal
        };
    },
    data() {
        return {
            payment_response: new resp() as resp,
            initialised_payment: false as boolean,
            ttc_payment_form: false as boolean,
            finalised_payment: true as boolean,
            storepaymentResponse: new payment_response() as payment_response,
            paymentprovider_url: "",
            paymentiframe_url: "",
            showAltUrl: false,
            is_payment_method_payment_gateway: false as boolean,
            is_payment_method_cybersource: false as boolean,
            is_payment_method_stripe: false as boolean,
            is_payment_method_paypal: false as boolean,
            is_payment_method_bank_transfer: false as boolean,
            is_payment_provider_available_ttc_payment_gateway: false as boolean,
            is_payment_provider_available_cybersource: false as boolean,
            is_payment_provider_available_stripe: false as boolean,
            is_payment_provider_available_paypal: false as boolean,
            is_iFrame: true as boolean,
            hide_payment_ttcgateway : true as boolean,
            hide_payment_paypal : true as boolean,
            hide_payment_paymentprovider_button : true as boolean,
            hide_payment_paymentprovider_iframe : true as boolean,
            show_fallback_button: false as boolean,
            show_redirect_msg: false as boolean,
            show_payment_methods: false as boolean,
            show_hints: false as boolean,
            available_payment_methods : [] as string[],
            selected_payment_provider: "" as string,
            paypal_payment_initialise : null as response | null,
            supportedProviderMethods: [] as supportedProviderMethod[], 
            show_logos : false as boolean,
            payment_logos: [
                { 
                    name: 'Visa', 
                    href: '',
                    svg: `<svg viewBox="0 0 36 24" class="h-3.5 w-auto" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="36" height="24" rx="3" fill="#0E4595"/><path d="M14.6 16.5L16.4 8.5H18.9L17.1 16.5H14.6ZM23.3 8.7C22.8 8.5 22.1 8.3 21.2 8.3C19 8.3 17.4 9.5 17.4 11.2C17.4 12.5 18.5 13.2 19.3 13.6C20.2 14.1 20.5 14.4 20.5 14.8C20.5 15.4 19.7 15.7 19 15.7C18 15.7 17.3 15.5 16.7 15.2L16.3 17.1C17 17.4 18 17.6 19.1 17.6C21.5 17.6 23 16.4 23 14.6C23 13.1 22.1 12.3 20.8 11.7C20 11.3 19.6 11 19.6 10.5C19.6 10.1 20.1 9.7 20.9 9.7C21.7 9.7 22.4 9.9 22.8 10.1L23.3 8.7ZM28.6 8.5H26.7C26.1 8.5 25.7 8.7 25.5 9.2L22 16.5H24.6L25.1 15.1H28.2L28.5 16.5H30.8L28.6 8.5ZM25.8 13.2L26.9 10.2L27.6 13.2H25.8ZM13.3 8.5L10.8 14L10.5 12.6C10.1 11.1 8.7 9.4 7.2 8.6L9.5 16.5H12.1L16 8.5H13.3Z" fill="white"/></svg>`
                },
                { 
                    name: 'Mastercard', 
                    href: '',
                    svg: `<svg viewBox="0 0 36 24" class="h-3.5 w-auto" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="36" height="24" rx="3" fill="#1A1F71"/><circle cx="14" cy="12" r="6" fill="#EB001B"/><circle cx="22" cy="12" r="6" fill="#F79E1B"/><path d="M18 7.3A5.96 5.96 0 0 0 15.8 12A5.96 5.96 0 0 0 18 16.7A5.96 5.96 0 0 0 20.2 12A5.96 5.96 0 0 0 18 7.3Z" fill="#FF5F00"/></svg>`
                },
                { 
                    name: 'Amex', 
                    href: '',
                    svg: `<svg viewBox="0 0 36 24" class="h-3.5 w-auto" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="36" height="24" rx="3" fill="#006FCF"/><path d="M7 15.5L8.5 12.2L10 15.5H12L9.5 10L12 4.5H10L8.5 7.8L7 4.5H5L7.5 10L5 15.5H7ZM13 15.5H19V13.8H15V11H18.5V9.3H15V7.2H19V5.5H13V15.5ZM20 15.5H22V10.5L24.5 15.5H26.5L29 10.5V15.5H31V5.5H28.5L25.5 11.5L22.5 5.5H20V15.5Z" fill="white"/></svg>`
                },
                { 
                    name: 'Klarna', 
                    href: '',
                    svg: `<svg viewBox="0 0 36 24" class="h-3.5 w-auto" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="36" height="24" rx="3" fill="#FFB3C7"/><path d="M12 7H14.5V17H12V7ZM17.5 7H20V11.5L23.5 7H26.5L22.3 12.2L26.8 17H23.7L20 12.9V17H17.5V7ZM28.5 15.5A1.5 1.5 0 1 1 28.5 18.5A1.5 1.5 0 0 1 28.5 15.5Z" fill="#0A0A0A"/></svg>`
                },
                { 
                    name: 'Apple Pay', 
                    href: '',
                    svg: `<svg viewBox="0 0 36 24" class="h-3.5 w-auto" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="36" height="24" rx="3" fill="#000000"/><path d="M13.6 11C13.6 9.8 14.3 9 15.4 8.3C14.7 7.4 13.6 7.2 13.2 7.2C12 7.1 11 7.9 10.4 7.9C9.8 7.9 8.9 7.2 7.9 7.2C6.7 7.2 5.5 7.9 4.9 9C3.6 11.2 4.6 14.5 5.8 16.3C6.4 17.1 7.1 18 8 18C8.9 18 9.2 17.4 10.3 17.4C11.3 17.4 11.6 18 12.5 18C13.4 18 14 17.2 14.6 16.4C15.3 15.4 15.6 14.4 15.6 14.3C15.5 14.3 13.6 13.5 13.6 11ZM12.3 5.9C12.8 5.3 13.2 4.4 13.1 3.5C12.3 3.5 11.3 4.1 10.8 4.7C10.3 5.3 9.9 6.2 10 7.1C10.9 7.2 11.8 6.5 12.3 5.9ZM18.5 7.4H20.6V17.9H18.5V15.7H18.4C17.9 16.5 16.8 17.1 15.7 17.1C13.7 17.1 12.3 15.4 12.3 12.6C12.3 9.8 13.7 8.1 15.7 8.1C16.8 8.1 17.8 8.7 18.3 9.5H18.5V7.4ZM16.6 15.2C17.9 15.2 18.7 14.1 18.7 12.6C18.7 11.1 17.9 10 16.6 10C15.3 10 14.5 11.1 14.5 12.6C14.5 14.1 15.3 15.2 16.6 15.2Z" fill="white"/></svg>`
                },
                { 
                    name: 'Google Pay', 
                    href: '',
                    svg: `<svg viewBox="0 0 36 24" class="h-3.5 w-auto" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="36" height="24" rx="3" fill="#000000"/><path d="M13.6 11C13.6 9.8 14.3 9 15.4 8.3C14.7 7.4 13.6 7.2 13.2 7.2C12 7.1 11 7.9 10.4 7.9C9.8 7.9 8.9 7.2 7.9 7.2C6.7 7.2 5.5 7.9 4.9 9C3.6 11.2 4.6 14.5 5.8 16.3C6.4 17.1 7.1 18 8 18C8.9 18 9.2 17.4 10.3 17.4C11.3 17.4 11.6 18 12.5 18C13.4 18 14 17.2 14.6 16.4C15.3 15.4 15.6 14.4 15.6 14.3C15.5 14.3 13.6 13.5 13.6 11ZM12.3 5.9C12.8 5.3 13.2 4.4 13.1 3.5C12.3 3.5 11.3 4.1 10.8 4.7C10.3 5.3 9.9 6.2 10 7.1C10.9 7.2 11.8 6.5 12.3 5.9ZM18.5 7.4H20.6V17.9H18.5V15.7H18.4C17.9 16.5 16.8 17.1 15.7 17.1C13.7 17.1 12.3 15.4 12.3 12.6C12.3 9.8 13.7 8.1 15.7 8.1C16.8 8.1 17.8 8.7 18.3 9.5H18.5V7.4ZM16.6 15.2C17.9 15.2 18.7 14.1 18.7 12.6C18.7 11.1 17.9 10 16.6 10C15.3 10 14.5 11.1 14.5 12.6C14.5 14.1 15.3 15.2 16.6 15.2Z" fill="white"/></svg>`
                },
                { 
                    name: 'PayPal', 
                    href: '/logo-paypal.svg',
                    svg: `<svg viewBox="0 0 36 24" class="h-3.5 w-auto" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="36" height="24" rx="3" fill="#003087"/><path d="M13.5 7H17.5C19.5 7 20.8 7.9 20.5 9.9C20.2 11.7 18.8 12.8 16.8 12.8H14.8L14 17H11.5L13.5 7Z" fill="#0079C1"/><path d="M15 9H19C21 9 22.3 9.9 22 11.9C21.7 13.7 20.3 14.8 18.3 14.8H16.3L15.5 19H13L15 9Z" fill="#00457C"/></svg>`
                },
                { 
                    name: 'Stripe', 
                    href: '/logo-stripe.svg',
                    svg: ``
                },
                { 
                    name: 'Cybersource', 
                    href: '/logo-cybersource.svg',
                    svg: ``
                },
                { 
                    name: 'TTC_Payment_Gateway', 
                    href: '/logo-ttc-black.svg',
                    svg: ``
                }
            ],
            is_Test: false as boolean //set this to true to test a response without going through the payment provider. DO NOT COMMIT WITH THIS SET TO TRUE
        }
    },
    methods: {
        get_Booking(): booking_search_group {
            return this.$store.getters.get_Booking;
        },
        async check_out_page() {
            this.show_hints = (import.meta.env.VITE_PAYMENT_SHOW_HINTS === "true") ? true : false;
            this.show_redirect_msg = true;
            this.is_iFrame = JSON.parse(import.meta.env.VITE_PAYMENT_PAYMENTPROVIDER_USE_IFRAME);

            if (this.get_payment_provider() == null || this.get_payment_provider() == "") {
                let default_method : string = await this.initialise_available_providers(null);
                if (default_method != "") {
                    //only one method so set as default
                    let is_nett_sale = this.$store.getters.get_Selected_Payment.nett_gross == "N";
                    this.set_payment_provider(default_method, is_nett_sale)
                } else {
                    //there are multiple methods, so let the user decide
                    this.show_payment_methods = true;
                    return;
                }
            } else if (this.available_payment_methods == null  || this.available_payment_methods.length == 0) {
                let default_method : string = await this.initialise_available_providers(this.get_payment_provider());
            }

            this.is_payment_method_payment_gateway = (this.get_payment_provider() == 'ttc_payment_gateway');
            this.is_payment_method_cybersource = (this.get_payment_provider() == 'cybersource');
            this.is_payment_method_stripe = (this.get_payment_provider() == 'stripe');
            this.is_payment_method_paypal = (this.get_payment_provider() == 'paypal');
            this.is_payment_method_bank_transfer = (this.get_payment_provider() == 'bank_transfer');

            //don't offer method choice when method hasbeen selected except for Paypal as it is rendered inline
            if (this.is_payment_method_paypal) {
                this.show_payment_methods = true;
                this.initPaypal();
                this.hide_payment_paypal = false;
                return;
            }

            this.show_payment_methods = false;

            if ((this.is_payment_method_cybersource || this.is_payment_method_stripe) && this.is_iFrame) {
                window.addEventListener("message", this.paymentprovider_confirmation_redirect, false);
            }

            if (this.$store.getters.get_Agent_Login?.payment_methods.length > 0) {
                let has_cc_payment_method : boolean = false;
                let has_bt_payment_method : boolean = false;
                this.$store.getters.get_Agent_Login.payment_methods.forEach(pm => {
                    if (pm.method == "CC") {
                        has_cc_payment_method = true;
                    }
                    else if (pm.method == "BT") {
                        has_bt_payment_method = true;
                    }
                });

                if (has_cc_payment_method) {
                    if (this.consumer_display == "false") {
                        await this.Initialise_Payment(false, this.$store.getters.get_Selected_Payment.nett_gross == "N");
                    }
                } else if (has_bt_payment_method) {
                    this.initialised_payment = true;
                    this.ttc_payment_form = false;
                    this.finalised_payment = true;
                } else {
                    this.initialised_payment = true;
                    this.ttc_payment_form = true;
                    this.finalised_payment = true;
                }
            } else {
                if (this.consumer_display == "true") {
                    await this.Initialise_Payment(true, this.$store.getters.get_Selected_Payment.nett_gross == "N");
                }
            }
        },
        async initialise_available_providers(restrict_to_payment_provider : string | null) : Promise<string> {
            let default_method : string = "";
            let providers = await this.get_payment_available_providers();
            if (providers != null) {
                this.available_payment_methods = [];
                this.supportedProviderMethods = [];
                providers.forEach(p => {
                    if (p.payment_method?.toLocaleLowerCase() == p.payment_processor?.toLocaleLowerCase()) {//no payment_links 

                        if (restrict_to_payment_provider != null && restrict_to_payment_provider != '' && restrict_to_payment_provider.toLowerCase() != p.payment_processor?.toLowerCase()) return;

                        switch (p.payment_processor?.toLocaleLowerCase()) {
                            case 'cybersource' :
                                this.is_payment_provider_available_cybersource = true;
                                this.available_payment_methods.push('cybersource');
                                break;
                            case 'stripe' :
                                this.is_payment_provider_available_stripe = true;
                                this.available_payment_methods.push('stripe');
                                break;
                            case 'paypal' :
                                this.is_payment_provider_available_paypal = true;
                                this.available_payment_methods.push('paypal');
                                break;
                            case 'ttc_payment_gateway' :
                                this.is_payment_provider_available_ttc_payment_gateway = true;
                                this.available_payment_methods.push('ttc_payment_gateway');
                                break;
                        }
                        let spm = new supportedProviderMethod();
                        spm.name = p.payment_processor?.toLocaleLowerCase() ?? "";
                        spm.accepts = p.accepts ?? [];
                        this.supportedProviderMethods.push(spm);
                    }
                })

                if (providers.length == 1) {
                    default_method = providers[0].payment_processor ?? "";
                }
            }
            else { //fallback to config
                this.available_payment_methods = import.meta.env.VITE_PAYMENT_METHOD.split(','); 
                this.is_payment_provider_available_cybersource = (this.available_payment_methods.indexOf('cybersource') > -1) ? true : false;
                this.is_payment_provider_available_stripe = (this.available_payment_methods.indexOf('stripe') > -1) ? true : false;
                this.is_payment_provider_available_paypal = (this.available_payment_methods.indexOf('paypal') > -1) ? true : false;
                this.is_payment_provider_available_ttc_payment_gateway = (this.available_payment_methods.indexOf('ttc_payment_gateway') > -1) ? true : false;
            
                //only use default payment method if there is only one available payment method
                if (import.meta.env.VITE_PAYMENT_METHOD.indexOf(',') == -1) {
                    default_method = import.meta.env.VITE_PAYMENT_METHOD;
                }

            }
            return default_method;
        },
        async get_payment_available_providers() : Promise<response_method[]> {
            var get_Booking = this.$store.getters.get_Booking;
            return await Pay.Payment_Available_Providers_And_Methods(this.Get_Payment_App_Id(), get_Booking.trips[0].iso_currency_code).then(response => { return response.json(); });
        },
        async set_payment_provider_and_checkout(payment_provider: string) {
            this.selected_payment_provider = payment_provider;
            let payment_session_old : request_payment_initialise_internal = this.$store.getters.get_Payment_Session;
            this.set_payment_provider(payment_provider, payment_session_old?.payment_initialise?.nett_sale ?? this.$store.getters.get_Selected_Payment.nett_gross == "N");
            await this.check_out_page();
        },
        Get_Payment_App_Id(): string {
            let payment_app_id : any = import.meta.env.VITE_PAYMENT_APP_ID; //default
            if (this.$store.getters.get_Payment_APP_ID != null && this.$store.getters.get_Payment_APP_ID != '') {
                payment_app_id = this.$store.getters.get_Payment_APP_ID; //set by paylink
            }
            return payment_app_id;
        },
        has_Payment_Session() : boolean {
            let Payment_Session = this.$store.getters.get_Payment_Session;
            if (!(Payment_Session == undefined || Payment_Session == null || Payment_Session.payment_session == null)) {
                return true;
            }
            return false;
        },
        async Initialise_Payment(consumer_sale: boolean, nett_sale: boolean) {
            var is_Full_Payment : boolean = this.$store.getters.get_Payment_Full_Payment;
            var is_Deposit_Payment : boolean = this.$store.getters.get_Payment_Deposit;
            var get_Booking = this.$store.getters.get_Booking;
            var is_consumer_sale = consumer_sale;
            var is_nett_sale = nett_sale;
            
            let payment_session : request_payment_initialise_internal;
            if (this.has_Payment_Session()) {
                payment_session = this.$store.getters.get_Payment_Session;

                //var is_Full_Payment : boolean = payment_session.payment_initialise.full_payment ?? true;
                //var is_Deposit_Payment : boolean = payment_session.payment_initialise.deposit ?? false;
                get_Booking = payment_session?.get_booking;
                is_nett_sale = payment_session?.payment_initialise.nett_sale ?? false;
            }

            let provider_name : string | null = null;
            if (this.selected_payment_provider != null && this.selected_payment_provider != "") {
                provider_name = this.selected_payment_provider;
            } else {
                provider_name = payment_session?.provider_name;
            }

            let Payment_Initialise: response = await Pay.Payment_Initialise(is_Full_Payment, is_Deposit_Payment, get_Booking, payment_session, this.$store.getters.get_Agent_Login, is_consumer_sale, is_nett_sale, this.Get_Payment_App_Id(), provider_name).then(response => { return response.json(); })
            let Payment_Method: response_method = Pay.get_payment_providerandmethod(Payment_Initialise, this.get_payment_provider());

            //store the session for use in the confirmation page
            let payment_session_id : string = Payment_Initialise.payment_session_id ?? "";
            payment_session = await Pay.Get_Payment_Session(this.$store, payment_session_id, provider_name, this.Get_Payment_App_Id());
            this.$store.commit('Payment_Session', { Payment_Session: payment_session });
            
            let payment_amount : number = this.getPaymentAmount(payment_session) ?? 0;
            let balance_outstanding : number | null = await this.get_balance_outstanding();
            //check if the balance outstanding is actually >= payment amount, if not route to confirmation to avoid overpayments
            if (balance_outstanding !== null && (balance_outstanding < payment_amount || payment_amount <= 0 || balance_outstanding <= 0)) {
                this.$router.push({ path: "/confirmation" });
                return;
            }

            await Pay.get_payment_providerandmethod(Payment_Initialise, this.get_payment_provider()).form_iframe;
            let Payment_Transation: payment = new payment();      
            if (provider_name.toLowerCase() != "stripe" && Payment_Method.data_payload != null) {
                Payment_Transation = JSON.parse(Payment_Method.data_payload ?? "");      
            }

            if (Payment_Transation.transactionInfo != null) Payment_Transation.transactionInfo.bookingType = "CD";

            if(!this.isAgent_Login() && !(this.isAAT() || this.isSEIT())) {
                Payment_Transation = this.setBlankDefaultAddress(Payment_Transation);
            }
            this.payment_response.ttc = Payment_Transation

            this.initialised_payment = true;
            this.ttc_payment_form = false;
            this.finalised_payment = true;

          
            if (this.is_payment_method_payment_gateway) {
                 this.hide_payment_ttcgateway = false;
                 if (this.is_Test) {
                    this.Payment_Processed(this.getTestPaymentResponse());
                 } else {
                    window.ttcPaymentgateway.attachPaymentOption(JSON.stringify(Payment_Transation), "#" + this.credit_card_div, (paymentResponse: payment_response) => {
                        this.Payment_Processed(paymentResponse);
                    });
                }
            } 
            else if (this.is_payment_method_cybersource || this.is_payment_method_stripe) {
                this.paymentprovider_url = await Pay.get_payment_providerandmethod(Payment_Initialise, this.get_payment_provider()).form_iframe ?? "";
                if (this.is_iFrame) {
                    this.paymentiframe_url = this.paymentprovider_url;
                    this.hide_payment_paymentprovider_iframe = false;
                } else {
                    window.location.href = this.paymentprovider_url;
                    setTimeout(() => { this.show_fallback_button = true; }, 3000);
                }
            }
            else if (this.is_payment_method_paypal) {
                this.hide_payment_paypal = false;
            }
            setTimeout(() => { this.show_redirect_msg = false; }, 3000);
        },
       async paypalCreateOrder() {
            try {
                var is_Full_Payment : boolean = this.$store.getters.get_Payment_Full_Payment;
                var is_Deposit_Payment : boolean = this.$store.getters.get_Payment_Deposit;
                var get_Booking = this.$store.getters.get_Booking;
                var is_consumer_sale = this.consumer_display == "true";
                var is_nett_sale = this.$store.getters.get_Selected_Payment.nett_gross == "N";
                
                let payment_session : request_payment_initialise_internal | null = null;
                if (this.has_Payment_Session()) {
                    payment_session = this.$store.getters.get_Payment_Session;

                    //var is_Full_Payment : boolean = payment_session.payment_initialise.full_payment ?? true;
                    //var is_Deposit_Payment : boolean = payment_session.payment_initialise.deposit ?? false;
                    get_Booking = payment_session?.get_booking;
                    is_nett_sale = payment_session?.payment_initialise.nett_sale ?? false;
                }

                let provider_name : string | null = this.get_payment_provider();
                let Payment_Initialise: response = await Pay.Payment_Initialise(is_Full_Payment, is_Deposit_Payment, get_Booking, payment_session, this.$store.getters.get_Agent_Login, is_consumer_sale, is_nett_sale, this.Get_Payment_App_Id(), provider_name).then(response => { return response.json(); })
                let Payment_Method: response_method = Pay.get_payment_providerandmethod(Payment_Initialise, this.get_payment_provider());

                //store the session for use in the confirmation page
                let payment_session_id : string = Payment_Initialise.payment_session_id ?? "";
                payment_session = await Pay.Get_Payment_Session(this.$store, payment_session_id, provider_name, this.Get_Payment_App_Id());
                this.$store.commit('Payment_Session', { Payment_Session: payment_session });

                this.paypal_payment_initialise = Payment_Initialise;

                let payment_amount : number = this.getPaymentAmount(payment_session) ?? 0;
                let balance_outstanding : number | null = await this.get_balance_outstanding();
                //check if the balance outstanding is actually >= payment amount, if not route to confirmation to avoid overpayments
                if (balance_outstanding !== null && (balance_outstanding < payment_amount || payment_amount <= 0 || balance_outstanding <= 0)) {
                    this.$router.push({ path: "/confirmation" });
                    return;
                }
        
                // let payload_json = JSON.parse(Payment_Initialise.payment_methods[0].data_payload ?? "");
                // const payload = new DataPayload(payload_json);
                let payload = JSON.parse(Payment_Initialise.payment_methods[0].data_payload ?? "");

                if (payload.paypal_order.Id) {
                    return payload.paypal_order.Id;
                }
                const errorDetail = payload.paypal_order?.Details?.[0];
                const errorMessage = errorDetail
                    ? `${errorDetail.issue} ${errorDetail.description} (${payload.paypal_order.Debug_id})`
                    : JSON.stringify(payload.paypal_order);

                throw new Error(errorMessage);
            } catch (error) {
                console.error(error);
                this.paypalResultMessage(`Could not initiate PayPal Checkout...<br><br>${error}`);
            }
        },
        async onPaypalApprove(data: any, actions: any) {
            try {
                let order_id = data.orderID;

                var is_Full_Payment : boolean = this.$store.getters.get_Payment_Full_Payment;
                var is_Deposit_Payment : boolean = this.$store.getters.get_Payment_Deposit;
                var get_Booking = this.$store.getters.get_Booking;
                var is_consumer_sale = this.consumer_display == "true";
                var is_nett_sale = this.$store.getters.get_Selected_Payment.nett_gross == "N";
               
                //let payment_session : request_payment_initialise_internal = this.paypal_payment_session ?? this.$store.getters.get_Payment_Session;
                //var is_Full_Payment : boolean = payment_session.payment_initialise.full_payment ?? true;
                //var is_Deposit_Payment : boolean = payment_session.payment_initialise.deposit ?? false;
                //get_Booking = payment_session?.get_booking;
                //is_nett_sale = payment_session?.payment_initialise.nett_sale ?? false;

                let provider_name : string | null = null;
                // if (this.selected_payment_provider != null && this.selected_payment_provider != "") {
                    provider_name = this.selected_payment_provider;
                //} else {
                //    provider_name = payment_session?.provider_name;
                //}
                
                let capture_repsonse : return_status = await Pay.Payment_Capture(is_Full_Payment, is_Deposit_Payment, get_Booking, this.paypal_payment_initialise, this.$store.getters.get_Agent_Login, is_consumer_sale, is_nett_sale, this.Get_Payment_App_Id(), provider_name, order_id).then(response => { return response.json(); })

                if (capture_repsonse.error_information != null && capture_repsonse.error_information != "") {
                    this.paypalResultMessage(capture_repsonse.error_information);
                    throw new Error(capture_repsonse.error_information);
                }

                //let payload_json = JSON.parse(await capture_repsonse.return_data ?? "");
                //const payload = new DataPayload(payload_json);
                const returnData = JSON.parse(await capture_repsonse?.return_data);

                const orderData = returnData.paypal_order;
                // Three cases to handle:
                //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                //   (2) Other non-recoverable errors -> Show a failure message
                //   (3) Successful transaction -> Show confirmation or thank you message

                const errorDetail = orderData?.Details?.[0];

                if (errorDetail?.Issue === "INSTRUMENT_DECLINED") {
                    // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                    // recoverable state, per
                    // https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
                    return actions.restart();
                } else if (errorDetail) {
                    // (2) Other non-recoverable errors -> Show a failure message
                    throw new Error(
                        `${errorDetail.Description} (${orderData.DebugId})`
                    );
                } else if (!orderData.PurchaseUnits) {
                    throw new Error(JSON.stringify(orderData));
                } else {
                    // (3) Successful transaction -> Show confirmation or thank you message
                    // Or go to another URL:  actions.redirect('thank_you.html');
                    const transaction =
                        orderData?.PurchaseUnits?.[0]?.Payments?.Captures?.[0] ||
                        orderData?.PurchaseUnits?.[0]?.Payments?.Authorizations?.[0];
                    this.paypalResultMessage(
                        `Transaction ${transaction.Status}: ${transaction.Id}<br>
                        <br>See console for all available details`
                    );
                    console.log(
                        "Capture result",
                        orderData,
                        JSON.stringify(orderData, null, 2)
                    );

                    this.$router.push({ path: "/confirmation" })
                }
            } catch (error) {
                console.error(error);
                this.paypalResultMessage(
                    `Sorry, your transaction could not be processed...<br><br>${error}`
                );
            }
        },
        paypalResultMessage(message) {
            let container = document.querySelector("#paypal-result-message");
            if (container != null) container.innerHTML = message;
        },
        initPaypal() {
            const self = this; // Store reference to the Vue component instance

            const script = document.createElement('script');

            //TODO get from payment init/provider call instead of from config
            script.src = import.meta.env.VITE_PAYMENT_PAYPAL_LIBRARY;
            
            let iso_currency_code = this.$store.getters.get_Currency.currency_info?.iso_currency_code ?? null;
            if (iso_currency_code != null) {
                script.src = script.src + '&currency=' + iso_currency_code;
            }

            script.addEventListener('load', () => {
                window.paypal.Buttons({
                    style: {
                        shape: "pill",
                        layout: "vertical",
                        color: "gold",
                        label: "paypal",
                    },
                    createOrder: async () => {
                        return await self.paypalCreateOrder();
                    },
                    // Use 'self' instead of 'this' to reference the component instance
                    onApprove: async (data: any, actions: any) => {
                        await self.onPaypalApprove(data, actions);
                    },
                    onError: (err: any) => {
                        console.error('PayPal Error:', err);
                    }
                }).render('#paypal-button-container');
            });

            document.body.appendChild(script);
        },
        isAAT(): boolean {
            if (import.meta.env.VITE_DEFAULT_PARENT == "AAT") {
                return true;
            }
            return false;
        },
        isSEIT(): boolean {
            if (import.meta.env.VITE_DEFAULT_PARENT == "SEIT") {
                return true;
            }
            return false;
        },
        getPaymentAmount(payment_session : request_payment_initialise_internal | null) : number {
            let amount : number = 0;
            let fee : number = 0;
            payment_session?.payment_initialise?.payments?.forEach(p => {
                fee = fee + (p.fee ?? 0);
            });

            amount = payment_session?.payment_initialise?.amount ?? 0;

            return amount - fee;
        },
        async get_balance_outstanding(): Promise<number | null> {
            let group_booking_id = this.$store.getters.get_Booking?.group_booking_id;

            let booking_details_old = await Book.Get_Book(group_booking_id.toString(), this.$store.getters.get_Agent_Login);
            let session_id = booking_details_old.session_id ?? "";

            let booking_details = await Book.Get_Booking_Session(this.$store, group_booking_id.toString(), session_id).then((response) => {
                return response;
            });

            let provider = this.get_payment_provider();
            let payment_session_id = this.$store.getters.get_Payment_Session?.payment_session?.toString() ?? "";    

            //retrieve the payment session from the store and update it with the latest payment booking details
            let payment_session_old : request_payment_initialise_internal = this.$store.getters.get_Payment_Session;
            if (payment_session_old != null ) {
                let provider = payment_session_old?.provider_name;
                let payment_session_id = payment_session_old?.payment_session?.toString() ?? "";
            }

            let app_id = this.get_Payment_App_Id();
            if (payment_session_id == null || payment_session_id == "" || provider == null || provider == "") {
                return null;
            }

            let payment_session : request_payment_initialise_internal = await Pay.Get_Payment_Session(this.$store, payment_session_id, provider ?? "", app_id);
            
            if (payment_session == null) {
                return null;
            }

            payment_session.provider_name = provider;

            if (booking_details.trips != null && booking_details.trips.length > 0) {
                payment_session.get_booking.trips = booking_details.trips;
            } else {
                booking_details = payment_session?.get_booking;
            }
            this.$store.commit('Payment_Session', { Payment_Session: payment_session });

            this.set_payment_provider(provider, payment_session.payment_initialise.nett_sale);

            this.$store.commit("Setup_Booking", { Booking_Details: booking_details });

            return Book.get_total_outstanding(booking_details);
        },
        get_Payment_App_Id(): string {
            let payment_app_id : any = import.meta.env.VITE_PAYMENT_APP_ID; //default
            if (this.$store.getters.get_Payment_APP_ID != null && this.$store.getters.get_Payment_APP_ID != '') {
                payment_app_id = this.$store.getters.get_Payment_APP_ID; //set by paylink
            }
            return payment_app_id;
        },
        get_payment_provider(): string {
            let method : string = "";

            if (this.$store.getters.get_Selected_Payment != null && this.$store.getters.get_Selected_Payment.provider != null) {
                method = this.$store.getters.get_Selected_Payment.provider;
            }

            return method;
        },
        set_payment_provider(provider: string, is_nett_sale: boolean = false) {
            //set it in the store so that it can be used by other components
            let selected_payment_method : response_login_payment = this.$store.getters.get_Selected_Payment;
            selected_payment_method.method = 'CC';
            selected_payment_method.nett_gross = (is_nett_sale == true) ? "N" : "G";
            selected_payment_method.description = 'CreditCard';
            selected_payment_method.provider = provider;
            this.$store.commit("Set_Payment_Selected", { Selected_Payment: selected_payment_method});
        },
        redirect_to_paymentprovider() {
            window.location.href = this.paymentprovider_url; // full page
        },
        paymentprovider_confirmation_redirect(event) {
            if(event.origin !== import.meta.env.VITE_DEFAULT_URL && event.origin !== 'http://localhost:3001') return;

            if (this.is_payment_method_cybersource || this.is_payment_method_stripe) this.$router.push({ path: "/confirmation" });
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        onLoadIframe(event) {
        },
        async Payment_Processed(Payment_Response: payment_response) {

            console.log("Payment Response", Payment_Response);

            this.payment_response.response_payment = Payment_Response;

            if(Payment_Response?.paymentSuccessful == false) {
                this.$router.push({name: 'failed_payment', params: { reason: "reason="+Payment_Response?.paymentStatus} });
            }
            else if (Payment_Response?.paymentSuccessful != null) {
                this.finalised_payment = false;
                this.ttc_payment_form = true;
                this.showAltUrl = false;
                
                let Return_Status = await Pay.Commit_Payment(this.payment_response, this.Get_Payment_App_Id());

                this.$router.push({ path: "/confirmation" });
            }

            this.finalised_payment = true;
        },
        setBlankDefaultAddress(payment: payment): payment {
            payment.transactionInfo.addressCity = "";
            payment.transactionInfo.addressCountry = "";
            payment.transactionInfo.addressLine1 = "";
            payment.transactionInfo.addressLine2 = "";
            payment.transactionInfo.addressPostalCode = "";

            return payment;

        },
        openPaymentProvider() {
            window.open(this.paymentprovider_url, "_blank"); //_self
        },
        GetBrand(): string {
            return String(import.meta.env.VITE_DEFAULT_CLASS);
        },
        getTestPaymentResponse(): payment_response {
            var paymentResponse = new payment_response();
            paymentResponse.paymentSuccessful = true;
            paymentResponse.event = "paymentAttemptResult";
            paymentResponse.transactionRef = "AAAUDS-TTC-3094317-4";
            paymentResponse.paymentSuccessful = true;
            paymentResponse.paymentStatus = "Authorised";
            paymentResponse.customSuccessPage = false;
            paymentResponse.paymentDetails.transactionId = "7811693948206052204506";
            paymentResponse.paymentDetails.billToFirstName = "Barry";
            paymentResponse.paymentDetails.billToLastName = "Test";
            paymentResponse.paymentDetails.billToAddressLine1 = "6 Canning Street";
            paymentResponse.paymentDetails.billToAddressLine2 = "Atholl Exchange, RadicalTravel";
            paymentResponse.paymentDetails.billToAddressCity = "Edinburgh";
            paymentResponse.paymentDetails.billToAddressState = "SCT";
            paymentResponse.paymentDetails.billToAddressCountry = "GB";
            paymentResponse.paymentDetails.billToAddressPostalCode = "Eh3 8eg";
            paymentResponse.paymentDetails.lastFourDigits = "1111";
            paymentResponse.paymentDetails.amount.currency = "AUD";
            paymentResponse.paymentDetails.amount.fee = "0";
            paymentResponse.paymentDetails.amount.total = "11.11";
            paymentResponse.paymentDetails.paymentMethod = "creditcard";
            return paymentResponse;
        }
    },
    mounted() {
        this.check_out_page();
    }
})